<template>
  <!-- 添加或编辑对话框 -->
  <el-dialog class="xiaobu-form-dialog" :title="baseForm.outId ? (isEdit ? '编辑出库单' : '查看出库单') : '新增出库单'" v-bind="$attrs"
    v-on="$listeners">
    <div class="edit-box flex-c-e" v-if="baseForm.outId && baseForm.outStatus === '0'">
      <el-button v-if="mixinHasPermi(['inventory:out:update'])" type="primary" class="edit" @click="toggleEdit">{{
        isEdit ? "取消编辑" : "编辑"
      }}</el-button>
    </div>
    <div class="el-dialog-body-child">
      <item-box class="base-info">
        <template v-slot:title>出库单基本信息</template>
        <template v-slot:content>
          <el-form class="clearfix" ref="dialogFormRef" :model="dialogForm" :rules="rules"
            :disabled="!!(!isEdit && baseForm.outId)" label-width="120px">
            <el-form-item v-if="baseForm.outId" class="half" label="出库单号" prop="outNo">
              <el-input disabled v-model.trim="dialogForm.outNo" clearable placeholder="请输入出库单号">
              </el-input>
            </el-form-item>
            <el-form-item class="half" label="出库类型" prop="outType">
              <el-select-dict dictType="OUT_TYPE" @dictChange="handleOutTypeChange" v-model.trim="dialogForm.outType"
                clearable placeholder="请选择出库类型" />
            </el-form-item>
            <el-form-item class="half" label="客户" v-if="!['2', '5'].includes(dialogForm.outType)" prop="customerName">
              <div class="box flex-c-s">
                <el-input disabled readonly v-model.trim="dialogForm.customerName" clearable
                  placeholder="请选择客户"></el-input>
                <el-button type="primary" v-if="dialogForm.outStatus !== '1'" size="mini" class="get-button"
                  @click="showSelectCustomer = true">搜索</el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="baseForm.outId && !isEdit" class="half" label="总数量" prop="outSumNumber">
              <el-input disabled v-model.trim="dialogForm.outSumNumber" clearable placeholder="请输入总数量"></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.outId && !isEdit" class="half" label="总成本价(元)" prop="outSumCostPrice">
              <el-input disabled v-model.trim="dialogForm.outSumCostPrice" clearable placeholder="请输入总成本价"></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.outId && !isEdit" class="half" label="总销售价(元)" prop="outSumSalesPrice">
              <el-input disabled v-model.trim="dialogForm.outSumSalesPrice" clearable
                placeholder="请输入总销售价"></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.outId && !isEdit" class="half" label="总利润(元)" prop="profiAmount">
              <el-input disabled v-model.trim="profiAmount" clearable placeholder="请输入总利润"></el-input>
            </el-form-item>
            <el-form-item v-if="baseForm.outId" class="half" label="出库状态" prop="outStatus">
              <el-tag-dict :value="dialogForm.outStatus" dictType="OUT_STATUS"></el-tag-dict>
            </el-form-item>
            <el-form-item class="all" label="备注" prop="remark">
              <el-input type="textarea" v-model="dialogForm.remark" :autosize="{ minRows: 5, maxRows: 8 }" clearable
                placeholder="请输入备注" />
            </el-form-item>
          </el-form>
        </template>
      </item-box>

      <item-box class="base-info">
        <template v-slot:title>商品明细</template>
        <template v-slot:content>
          <div class="btn-box" v-if="!baseForm.outId || baseForm.outStatus === '0'">
            <el-button type="primary" size="mini" :disabled="!!(!isEdit && baseForm.outId)"
              @click="handleAdd">添加商品</el-button>
            <el-button type="danger" size="mini" v-if="!(!isEdit && baseForm.outId)" :disabled="spuList.length === 0"
              @click="handleClearAll">清空商品</el-button>
          </div>
          <div class="tips flex-c-s" v-if="notAllowWareHouseNum !== 0">总共<el-text-dict style="padding: 0 6px;" type="primary">{{ total }}</el-text-dict>条数据，其中<el-text-dict style="padding: 0 6px;" type="warning">{{ notAllowWareHouseNum }}</el-text-dict>条无权限查看</div>
          <el-table :data="spuList" :row-class-name="getRowClassName">
            <el-table-column align="left" prop="goodsName" label="商品名称" min-width="128px"
              show-overflow-tooltip></el-table-column>
            <el-table-column align="left" prop="skuListStr" label="规格" min-width="128px"></el-table-column>
            <!-- <el-table-column align="center" prop="qualityGuaranteePeriod" label="保质期(天)"
              width="100px"></el-table-column> -->
            <el-table-column label="仓库" prop="wareHouseName" align="center" min-width="168px">
              <template slot-scope="scope">
                {{ getWareHouseName(scope.row.wareHouseId) }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="manufactureDate" label="生产日期" width="128px"></el-table-column>
            <el-table-column align="center" prop="costPrice" label="成本单价(元)" width="128px"></el-table-column>
            <el-table-column align="center" prop="salesPrice" label="销售单价(元)" width="152px">
              <template slot-scope="scope">
                <span v-if="!!(!isEdit && baseForm.outId) || ['2', '5'].includes(dialogForm.outType)">{{
                  scope.row.salesPrice }}</span>
                <el-input v-else @input="handleInput(scope.$index)" @blur="handleBlur(scope.$index)"
                  v-model="scope.row.salesPrice" placeholder="请输入"></el-input>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="spuNumber" label="库存数量" width="100px"></el-table-column>
            <el-table-column align="center" prop="outNumber" label="出库数量" width="160px">
              <template slot-scope="scope">
                <el-input-number class="number-input" :disabled="!!(!isEdit && baseForm.outId)"
                  v-model="scope.row.outNumber" :min="1" :max="scope.row.spuNumber"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column align="center" v-if="baseForm.outStatus !== '2' && !(!isEdit && baseForm.outId)" label="操作"
              width="88px">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="handleDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </item-box>

    </div>
    <div slot="footer" class="dialog-footer">
      <template>
        <el-button @click="$emit('close')">{{
          !baseForm.outId || isEdit ? "取 消" : "关 闭"
        }}</el-button>
        <el-button type="danger" @click="discardEntry" v-hasPermission="['inventory:out:discard']"
          v-show="baseForm.outId && !isEdit && baseForm.outStatus === '0'">作 废</el-button>
        <el-button type="primary" @click="submitForm" v-show="!baseForm.outId || isEdit">保 存</el-button>
        <el-button type="success" @click="pringOut"
          v-show="baseForm.outId && !isEdit && baseForm.outStatus !== '2'">打印出库单</el-button>
        <el-button type="primary" @click="pringOutNo(dialogForm)"
          v-show="baseForm.outId && baseForm.outStatus === '1'">打印出库单号</el-button>
        <el-button type="primary" @click="confirmOut"
          v-show="baseForm.outId && !isEdit && baseForm.outStatus === '0'">确认出库</el-button>

      </template>
    </div>
    <select-spu ref="selectSpu" :spuExpireStatus="spuExpireStatus" :wareHouseData="wareHouseData"
      :title="selectSpuTitle" width="1280px" :modal="true" :visible.sync="showSelectSpu" :selectIdArr="selectIdArr"
      @success="handleSuccess" @close="showSelectSpu = false" :modal-append-to-body="true" :append-to-body="true"
      :close-on-click-modal="false" />

    <out-print v-if="baseForm.outId && baseForm.outStatus !== '2'" ref="outNoRef" :spuList="spuList"
      :outData="dialogForm" :wareHouseData="wareHouseData"></out-print>

    <select-customer ref="selectCustomer" customerType="1"  title="选择客户" width="1000px" :modal="true" :visible.sync="showSelectCustomer"
      @handleSelect="handleSelectCustomer" @close="showSelectCustomer = false" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" />

    <out-tag v-if="baseForm.outId && baseForm.outStatus === '1'" ref="outTag"></out-tag>
  </el-dialog>
</template>
<script>
import { outApi } from "@/api"
import SelectSpu from "./select-spu.vue"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import OutPrint from "./out-print.vue"
import SelectCustomer from "@/components/select-customer/index.vue"
import Decimal from "decimal.js"
import OutTag from "./out-tag.vue"
export default {
  name: "OutDialog",
  components: { SelectSpu, OutPrint, SelectCustomer, OutTag },
  props: {
    wareHouseData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 是否是编辑
    isUpdate: {
      type: Boolean,
      default: false
    },
    //出库单数据
    baseForm: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      notAllowWareHouseNum: 0, // 无权限查看的数据条数
      total: 0, // 该入库单 商品条数
      selectSpuTitle: "选择商品",
      showSelectCustomer: false, // 选择客户
      spuExpireStatus: "", // 过期类型
      defaultProps: {
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      showSelectSpu: false,
      selectIdArr: [],
      spuList: [],
      isEdit: false, // 是否是在编辑
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {
        outType: [
          {
            required: true,
            message: "请选择出库单类型",
            trigger: ["blur", "change"]
          }
        ],
        customerName: [
          {
            required: true,
            message: "请选择客户",
            trigger: "change"
          }
        ]
      }
    }
  },
  computed: {
    // 利润
    profiAmount() {
      if (!this.dialogForm.outId || this.isEdit) {
        return 0.00
      }
      const outSumSalesPrice = new Decimal(this.dialogForm.outSumSalesPrice)
      const outSumCostPrice = new Decimal(this.dialogForm.outSumCostPrice)
      const price = outSumSalesPrice.minus(outSumCostPrice)
      return price.toFixed(2)
    }
  },
  watch: {
    showSelectCustomer(val) {
      if (!val) {
        // 关闭前调整遮罩层
        this.mixinRemoveAndAddMask()

        // 重置表单
        this.$refs.selectCustomer.resetQuery()
      }
    },
    showSelectSpu(val) {
      if (!val) {
        this.$refs.selectSpu.clearSelection()
        // 关闭前调整遮罩层
        this.mixinRemoveAndAddMask()
      }
    },
    isUpdate(val) {
      this.isEdit = val
    },
    // 监听baseForm变化 拷贝baseForm
    baseForm: {
      handler: function(val) {
        this.dialogForm = JSON.parse(JSON.stringify(val))
        if (this.dialogForm.customer) {
          this.dialogForm.customerName = this.dialogForm.customer?.customerName
        }
        // 渲染已选择的 商品列表
        this.renderSpuList()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 清空所有入库商品
    handleClearAll() {
      const _this = this
      this.$modal.confirm("确认清空所有出库商品吗？", {
        beforeClose: (action, instance, done) => {
          // 关闭前调整遮罩层
          _this.mixinRemoveAndAddMask()
          done()
        }
      }).then(() => {
        _this.spuList = []
      })
    },
    // 给表格行添加 类
    getRowClassName({ row, rowIndex }) {
      return row.hasError ? "error" : ""
    },
    // 打印出库单号
    pringOutNo(data) {
      this.$nextTick(() => {
        this.$refs.outTag && this.$refs.outTag.print(data)
      })
    },
    // 选择客户
    handleSelectCustomer(row) {
      this.showSelectCustomer = false

      // 关闭前调整遮罩层
      this.mixinRemoveAndAddMask()

      this.$set(this.dialogForm, "customerId", row.customerId)
      this.$set(this.dialogForm, "customerName", row.customerName)
      this.$nextTick(() => {
        this.$refs.dialogFormRef.validateField("customerName")
      })
    },
    // 失去焦点事件
    handleBlur(index) {
      // 若输入值不为空
      if (this.spuList[index]["salesPrice"]) {
        // 将输入值转换为浮点数
        const num = parseFloat(this.spuList[index]["salesPrice"])
        // 判断是否为有效的数字
        if (!isNaN(num)) {
          // 保留两位小数
          this.spuList[index]["salesPrice"] = num.toFixed(2)
        }
      } else {
        this.spuList[index]["salesPrice"] = "0.00"
      }
    },
    // 输入事件
    handleInput(index) {
      let value = this.spuList[index]["salesPrice"]
      // 移除非数字和小数点的字符
      value = value.replace(/[^\d.]/g, "")
      // 处理多个小数点的情况
      const parts = value.split(".")
      if (parts.length > 2) {
        value = parts[0] + "." + parts[1]
      }
      // 保留最多两位小数
      const match = value.match(/^\d+(\.\d{0,2})?/)
      if (match) {
        this.spuList[index]["salesPrice"] = match[0]
      } else {
        this.spuList[index]["salesPrice"] = ""
      }
    },
    handleOutTypeChange(val) {
      if (val === "2" || val === "5") {
        this.dialogForm.customerId = 1
        this.dialogForm.customerName = "我"
      } else {
        this.dialogForm.customerId = ""
        this.dialogForm.customerName = ""
      }
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate("customerName")
      })
      // 改变入库类型 得 清空 已选择的商品列表
      this.spuList = []
    },
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 作废
    discardEntry() {
      const _this = this
      _this.$modal
        .confirm('是否确认作废出库单号为"' + _this.dialogForm.outNo + '"的数据项？')
        .then(function() {
          return outApi.discardOut({ outId: _this.dialogForm.outId })
        })
        .then(() => {
          _this.$modal.msgSuccess("出库单作废成功")
          _this.$emit("close")
          _this.$emit("successs")
        }).finally((err) => {
          // 关闭前调整遮罩层
          this.mixinRemoveAndAddMask()
        })
    },
    // 确认出库
    confirmOut() {
      outApi.confirmOut({ outId: this.dialogForm.outId }).then(() => {
        this.$modal.msgSuccess("出库单确认成功")
        // 刷新角标
        this.$store.dispatch("user/getUserInfo")
        this.$emit("close")
        this.$emit("successs")
      })
    },
    // 打印出库单 
    pringOut() {
      this.$nextTick(() => {
        this.$refs.outNoRef && this.$refs.outNoRef.print()
      })
    },
    // 渲染已选择的 商品列表
    renderSpuList() {
      if (this.baseForm.outId && this.baseForm.outStatus === "1") {
        outApi.getOutDetail({ outId: this.baseForm.outId }).then(data => {
          this.spuList = data.rows || []
          this.total = data.total || 0
          this.notAllowWareHouseNum = data.notAllowWareHouseNum || 0
        })
        return
      }

      const spuIdArr = []
      const spuList = []
      const list = this.baseForm.spuListJson ? JSON.parse(this.baseForm.spuListJson) : []
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        const wareHouseId = (Array.isArray(item.wareHouseId) ? item.wareHouseId[item.wareHouseId.length - 1] : item.wareHouseId) || null
        if (!this.mixinPermiWareHouseIds.includes(wareHouseId)) {
          spuList.push({ ...item, hasError: true })
        } else {
          spuList.push({ ...item, hasError: false })
        }
        spuIdArr.push(item.spuId)
      }

      this.spuList = spuList
      // 去重一下
      this.selectIdArr = [... new Set(spuIdArr)]
    },
    // 删除
    handleDelete(index) {
      this.spuList.splice(index, 1)
    },
    // 点击新增
    handleAdd() {
      if (!this.dialogForm.outType) {
        this.$modal.msgError("请选择出库单类型")
        return
      }
      const obj = {
        "1": "选择商品（销售出库）",
        "2": "选择商品（过期出库）",
        "3": "选择商品（人情出库）",
        "4": "选择商品（外借出库）",
        "5": "选择商品（损坏出库）"
      }
      this.selectSpuTitle = obj[this.dialogForm.outType]
      if (this.dialogForm.outType === "2") {
        this.spuExpireStatus = "2" // 已过期
      } else if (this.dialogForm.outType === "3") {
        this.spuExpireStatus = "1" // 即将过期
      } else {
        this.spuExpireStatus = "0"
      }
      this.showSelectSpu = true
      const selectIdArr = this.spuList.map(item => { return item.wareHouseSpuId })
      // 去重
      this.selectIdArr = [...new Set(selectIdArr)]
    },
    // 选择好添加的单品
    handleSuccess(spuList) {
      this.showSelectSpu = false
      const list = []
      for (let i = 0; i < spuList.length; i++) {
        const item = spuList[i]
        // 旧的列表中是否存在
        const oldItem = this.spuList.find(childItem => { return childItem.wareHouseSpuId === item.wareHouseSpuId })
        if (oldItem) {
          list.push(oldItem)
        } else {
          list.push({
            ...item,
            // 过期出库 损坏出库 销售价为 0
            salesPrice: ["2", "5"].includes(this.dialogForm.outType) ? "0.00" : item.spuInfo.salesPrice,
            outNumber: this.dialogForm.outType === "2" ? item.spuNumber : 1 // 过期出库 默认最大数量
          })
        }
      }
      this.spuList = list
    },
    // 编辑或取消编辑
    toggleEdit() {
      if (!this.isEdit) {
        this.isEdit = true
        return
      }
      this.isEdit = false
      this.dialogForm = JSON.parse(JSON.stringify(this.baseForm))
      if (this.dialogForm.customer) {
        this.dialogForm.customerName = this.dialogForm.customer?.customerName
      }
      // 渲染已选择的 商品列表
      this.renderSpuList()
    },
    // 重置表单
    resetForm() {
      this.isEdit = false

      this.notAllowWareHouseNum = 0 // 无权限查看的数据条数
      this.total = 0 // 该入库单 商品条数
      this.$nextTick(() => {
        this.$refs.dialogFormRef.clearValidate()
      })
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["dialogFormRef"].validate(async valid => {
        if (valid) {
          if (this.spuList.length === 0) {
            this.$modal.msgError("请选择出库商品")
            return
          }

          this.dialogForm.spuList = this.spuList
          //更新
          if (this.dialogForm.outId) {
            outApi.updateItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("编辑出库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          } else {
            //新增
            outApi.createItem(this.dialogForm).then((data) => {
              this.$modal.msgSuccess("新增出库单成功")
              this.$emit("close")
              this.$emit("successs")
              this.spuList = []
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .item-box {
  .item-content-box {
    .el-table {
      .el-table__row {
        &.error {
          position: relative;

          &::after {
            content: "";
            pointer-events: none;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            position: absolute;
            top: 1px;
            left: 1px;
            border: 1px solid red;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

.el-dialog__body {
  .date-input {
    width: 160px;
  }

  .number-input {
    width: 136px;
  }

  .get-button {
    position: absolute;
    width: 88px;
    right: 4px;
    top: 50%;
    transform: translateY(calc(-50% + 2px));
  }
}
</style>